import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ResourcesOfEntity } from '../../models/projects.model';

@Component({
  selector: 'app-resources-tag-box',
  templateUrl: './resources-tag-box.component.html',
  styleUrls: ['./resources-tag-box.component.scss'],
})
export class ResourcesTagBoxComponent implements OnInit, OnDestroy {
  private _resourcesList: ResourcesOfEntity[] = [] as ResourcesOfEntity[];
  @Input() set resourcesList(value: ResourcesOfEntity[]) {
    this._resourcesList = value;
    this.checkIfResourcesListIsEmpty();
  }
  get resourcesList(): ResourcesOfEntity[] {
    return this._resourcesList;
  }

  @Output() resourcesListSelected: EventEmitter<number[]> =
    new EventEmitter<number[]>();

  public tagBoxEnabled: boolean = true;

  public itemsSelected: number[] = [];

  constructor() {}

  ngOnDestroy(): void {
    this._resourcesList = [] as ResourcesOfEntity[];
    this.tagBoxEnabled = true;
  }

  ngOnInit(): void {
    this.checkIfResourcesListIsEmpty();
  }

  private checkIfResourcesListIsEmpty(): void {
    if (this.resourcesList.length === 0) {
      this.tagBoxEnabled = true;
    } else {
      this.tagBoxEnabled = false;
    }
  }

  public onResourcesChanged(e: any): void {
    this.itemsSelected = e.value;
    this.resourcesListSelected.emit(this.itemsSelected);
  }
}
